import api from './AxiosService';

const CityService = {
  getAllCities: (params) => api.get('/cities/all', { params }),
  addCity: (data) => api.post('/cities/add', data),
  updateCity: (id, data) => api.put(`/cities/${id}`, data),
  toggleTopCity: (id) => api.put(`/cities/${id}/top`),
  deleteCity: (id) => api.delete(`/cities/${id}`),
  syncCities: () => api.post('/cities/sync'),
};

export default CityService;
